import * as React from 'react';
import appealsImage from '../../images/oneboardAppealsImage.svg'
import financeImage from '../../images/oneboardFinanceImage.svg'
import newsImage from '../../images/oneboardNewsImage.svg'
import accountsImage from '../../images/oneboardAccountsImage.svg'
import nextArrowIcon from '../../images/nextArrowIcon.svg'
import previousArrowIcon from '../../images/previousArrowIcon.svg'

const slides = [
    { image: financeImage, title: <>Отслеживайте историю начислений <br /> и оплачивайте счета</> },
    { image: accountsImage, title: <>Добавляйте лицевые счета <br />и переключайтесь между адресами</> },
    { image: newsImage, title: <>Получайте персональные <br />предложения по скидкам и акциям</> },
    { image: appealsImage, title: <>Оставляйте обращения <br />и контролируйте статус заявок</> }]


interface OneboardPageProps {
    oneboard_onClose: () => void;

}


interface OneboardPageState {
    selectedSlide: number
}

export default class OneboardPage extends React.PureComponent<OneboardPageProps, OneboardPageState> {

    constructor(props: OneboardPageProps) {
        super(props);
        this.state = { selectedSlide: 0 }
    }

    public render() {
        return (
            <div className='oneboard__wrapper'>
                <div className='oneboard'>
                    <div className='oneboard__miss'

                        style={{ visibility: this.state.selectedSlide !== slides.length - 1 ? "visible" : "hidden" }}>
                        <div className='button oneboard_miss-text' onClick={() => this.props.oneboard_onClose()}>Пропустить</div></div>
                    <div className='oneboard__slider'>
                        {slides.map((element, index) =>
                            <div key={index} className={`oneboard__slider_slide 
                            ${this.state.selectedSlide > index && "slided"}
                            ${this.state.selectedSlide === index && "selected"}`}>
                                <div className='oneboard_title-text'>{element.title}</div>
                                <img src={element.image}></img>
                            </div>)
                        }
                    </div>
                    <div className='oneboard__pagination'>
                        {slides.map((element, index) =>
                            <div key={index} className={`
                            ${this.state.selectedSlide === index && "selected"}
                            ${this.state.selectedSlide > index && "slided"}`}><div></div></div>)}
                    </div>
                    <div className='oneboard__buttons_wrapper'>
                        <div className='oneboard__button button'
                            style={{ visibility: this.state.selectedSlide === 0 ? "hidden" : "visible" }}
                            onClick={() => {
                                if (this.state.selectedSlide !== 0)
                                    this.setState({ selectedSlide: this.state.selectedSlide - 1 })
                            }}>
                            <img src={previousArrowIcon} />
                            <div className='oneboard_button-text'>Назад</div>
                        </div>
                        <div className={`oneboard__button button `}
                            style={{ display: this.state.selectedSlide === slides.length - 1 ? "none" : "flex" }}
                            onClick={() => {
                                if (this.state.selectedSlide !== slides.length - 1)
                                    this.setState({ selectedSlide: this.state.selectedSlide + 1 })
                            }}>
                            <div className='oneboard_button-text'>Далее</div>
                            <img src={nextArrowIcon} />
                        </div>

                        <div className={`oneboard__button accept button `}
                            style={{ display: this.state.selectedSlide === slides.length - 1 ? "flex" : "none" }}
                            onClick={() => this.props.oneboard_onClose()}>
                            <div className='oneboard_button-text'>Понятно</div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}